import React from 'react'
import StartingPage from '../StartingPage/StartingPage'

export default function Homepage() {
    return (
        <StartingPage />
    )
}
